import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useAppDispatch } from '@/app/store/hooks';
import { signedOut } from '@/features/auth';
import { baseApi } from '@/shared/api/baseApi';
import { clearTokens } from '@/shared/lib/tokenStorage';

/** Every Log out control routes through here. Order matters: the cache is reset
 *  before navigating so no screen can render one director's data while the next
 *  one signs in on the same device. */
export const useLogout = (): (() => void) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return useCallback(() => {
    clearTokens();
    dispatch(signedOut());
    dispatch(baseApi.util.resetApiState());
    void navigate('/logout', { replace: true });
  }, [dispatch, navigate]);
};
